import {createReducer, on} from "@ngrx/store";
import {ComplaintState} from "./complaint.state";
import {complaintActions} from "./complaint.actions";

function getInitialState() {
  return {
    loading: false,
    error: null,
  }
}

export const complaintReducer = createReducer<ComplaintState>(
  getInitialState(),
  on(complaintActions.trySaveComplaint, (state) => ({
    ...state,
    loading: true,
  })),
  on(complaintActions.saveComplaintSuccess, (state) => ({
    ...state,
    loading: false,
  })),
  on(complaintActions.saveComplaintError, (state, action) => ({
    ...state,
    loading: false,
    error: action.payload,
  }))
)
